/* eslint-disable array-callback-return */
import React from 'react';
import { SvgIcon } from '@material-ui/core';
import * as Yup from 'yup';
import setGiftCardPayment from '../operations/localState/setGiftCardPayment';

export const paymentValidationSchema = ({
  airPaymentCheckoutFirstNameErrorRequired,
  airPaymentCheckoutLastNameErrorRequired,
  airPaymentCheckoutCardNumberErrorRequired,
  airPaymentCheckoutExpireMonthErrorRequired,
  airPaymentCheckoutExpireYearErrorRequired,
}) =>
  Yup.object().shape({
    firstNameOnCard: Yup.string().required(airPaymentCheckoutFirstNameErrorRequired),
    lastNameOnCard: Yup.string().required(airPaymentCheckoutLastNameErrorRequired),
    cardNumber: Yup.string().required(airPaymentCheckoutCardNumberErrorRequired),
    expiryMonth: Yup.string().required(airPaymentCheckoutExpireMonthErrorRequired),
    expiryYear: Yup.string().required(airPaymentCheckoutExpireYearErrorRequired),
    cvv: Yup.string(),
  });

export const supportedCreditCardMap = {
  visa: 'VA',
  mastercard: 'MC',
  amex: 'AX',
  dinersclub: 'DC',
  discover: 'DS',
  jcb: 'JC',
};

export const getBannerIcon = () => {
  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
          <path
            d="M23.496 18.9688L13.7294 2.05225C13.372 1.43339 12.7117 1.05225 11.9972 1.05225C11.2826 1.05225 10.6223 1.43339 10.2649 2.05225L0.428013 19.0905C0.0708705 19.7094 0.0708705 20.4717 0.428013 21.0905C0.785442 21.7094 1.44573 22.0905 2.1603 22.0905H21.8343C21.8363 22.0905 21.8386 22.0905 21.84 22.0905C22.9446 22.0905 23.84 21.1951 23.84 20.0905C23.8397 19.6748 23.7132 19.2885 23.496 18.9688Z"
            stroke="white"
          />
          <path
            d="M12 6.93604C12.6172 6.93604 13.1178 7.43632 13.1178 8.05375L12.832 14.7197C12.8035 15.3226 12.3349 15.5518 12 15.5518C11.6249 15.5518 11.2009 15.354 11.168 14.7197L10.8823 8.05375C10.8823 7.43632 11.3829 6.93604 12 6.93604Z"
            fill="white"
          />
          <path
            d="M13.0086 18.9312C12.7454 19.1969 12.3768 19.3484 12 19.3484C11.6228 19.3484 11.2543 19.1969 10.9886 18.9312C10.7228 18.6655 10.5714 18.2969 10.5714 17.9198C10.5714 17.5426 10.7228 17.1769 10.9886 16.9112C11.2543 16.6455 11.6228 16.4912 12 16.4912C12.3768 16.4912 12.7454 16.6455 13.0086 16.9112C13.2771 17.1769 13.4286 17.5455 13.4286 17.9198C13.4286 18.2969 13.2771 18.6655 13.0086 18.9312Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
export const getGuests = (bookingProfileVar, searchParamsVar) =>
  searchParamsVar()?.guests?.map((guest, index) => {
    const formattedGuest = {
      id: guest.id,
      firstName: guest.flightGuest.firstName,
      lastName: guest.flightGuest.lastName,
      middleName: guest.flightGuest.middleName,
      knownTravelerNumber: guest.flightGuest.knownTravelerNumber,
      redressNumber: guest.flightGuest.redressNumber,
      frequentFlyer: guest.flightGuest.loyaltyPrograms
        ? guest.flightGuest.loyaltyPrograms.reduce((filtered, loyaltyProgram) => {
            if (loyaltyProgram.frequentFlyerProgramCode && loyaltyProgram.frequentFlyerNumber) {
              const formattedLoyaltyProgram = {
                frequentFlyerProgram: loyaltyProgram.frequentFlyerProgramCode,
                frequentFlyerNumber: loyaltyProgram.frequentFlyerNumber,
              };
              filtered.push(formattedLoyaltyProgram);
            }
            return filtered;
          }, [])
        : [],
    };

    if (index === 0) {
      formattedGuest.emailAddress = bookingProfileVar().bookingEmail || guest.email;
    }

    return formattedGuest;
  });

export const heldConfirmInputMap = (bookingProfileVar, heldReservationVar, searchParamsVar) => {
  return {
    bookingID: bookingProfileVar().flightProfile.id,
    correlationID: heldReservationVar().holdFlight.correlationID,
    hashKey: heldReservationVar().associatedHashKey,
    guests: getGuests(bookingProfileVar, searchParamsVar),
  };
};

const getOnlyGCPaymentAmount = (paymentInfo) => {
  return (
    paymentInfo &&
    paymentInfo
      .map((payment) => {
        if (payment.paymentMethod === 'GC') {
          return payment.amount;
        }
        return 0;
      })
      .reduce((prev, curr) => prev + (curr || 0), 0)
  );
};

const getCreditCardType = (paymentInfo) => {
  return (
    paymentInfo &&
    // eslint-disable-next-line consistent-return
    paymentInfo.map((payment) => {
      if (payment.paymentMethod === 'CC') {
        return payment.cardType;
      }
    })
  );
};

export const tokenizeCardAndBookFlight = (
  threeDsComponentElement,
  giftCardsFor3ds,
  paymentInput,
  bookFlight,
  heldConfirmInputInformation,
  showErrorvalidationBanner,
  setLoader,
  creditCard,
  onFinishTokenizeAndBook,
) => {
  // trigger tokenizeCards on form submit.
  threeDsComponentElement
    .tokenizeCards(giftCardsFor3ds)
    .then(async (threeDsSessionGiftCards) => {
      const haveErrors = threeDsSessionGiftCards.find((card) => card.errorDescription);
      if (!haveErrors) {
        const cardsTokens = creditCard ? [creditCard] : [];
        threeDsSessionGiftCards.forEach((giftcard) => {
          const { expirationMonth, expirationYear } = giftcard.paymentMethod;
          const foundCard = paymentInput.find((card) =>
            card.cardNumber.endsWith(giftcard.correlationId),
          );
          cardsTokens.push({
            cardType: 'VA',
            cardNumber: giftcard.paymentMethod.cardToken,
            expiration: String(expirationMonth).padStart(2, '0') + expirationYear.slice(-2),
            amount: foundCard.amount,
            cvv: foundCard.cvv,
            isThreeDsEligible: false,
            paymentMethod: 'GC',
          });
        });
        const gCPaymentAmount = getOnlyGCPaymentAmount(cardsTokens);
        const creditCardType = getCreditCardType(cardsTokens);
        const paymentTraker = { gCPaymentAmount, creditCardType: creditCardType[0] };
        setGiftCardPayment(paymentTraker);
        await bookFlight({
          variables: {
            heldConfirmInput: heldConfirmInputInformation,
            paymentInput: cardsTokens,
          },
        });
        onFinishTokenizeAndBook();
      } else {
        onFinishTokenizeAndBook();
        showErrorvalidationBanner();
      }
      setLoader(false);
    })
    .catch(() => {
      setLoader(false);
      showErrorvalidationBanner();
      onFinishTokenizeAndBook();
    });
};
